import React, { Fragment, useEffect, useState } from "react";

import Modal from "../../../components/modalComponent/ModalComponent";
import { requestsApiUpsellProvider } from "../../../lib/api/providers";
import RequestsList from "./Requests.modal";

const Requests = ({ token, currentClientId }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [requests, setRequests] = useState([]);
  const nbRequests = requests.length;
  const fetchRequests = async () => {
    const response = await requestsApiUpsellProvider.post(
      "/tovalidate",
      { client_id: currentClientId },
      {
        headers: {
          Authorization: token
        }
      }
    );
    if (Array.isArray(response.data)) {
      setRequests(response.data.filter(request => request.type === "pdc_update"));
    }
  };
  useEffect(() => {
    fetchRequests();
  }, []);

  return (
    <Fragment>
      <Modal
        title="Requêtes en attente"
        showModal={isModalVisible}
        closeModal={() => setIsModalVisible(false)}
        width={"90%"}
      >
        <RequestsList requests={requests} />
      </Modal>
      <div className="p-pdc-validation" onClick={() => setIsModalVisible(true)}>
        <b>{`${nbRequests} requête${nbRequests > 1 ? "s" : ""}`}</b> en attente de validation
      </div>
    </Fragment>
  );
};
export default Requests;



// WEBPACK FOOTER //
// src/containers/metier/pdcs/Requests.js